'use client';

import useOperatingSystem from '@/hooks/use-operating-system';

function OptionShiftKey() {
  const os = useOperatingSystem();

  return os === 'mac' ? '⌥' : 'Shift';
}

export default OptionShiftKey;
